{
  "metadata": {
    "id": "nightowl-dark",
    "name": "Night Owl",
    "description": "Портировано из темы «Night Owl» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "nightowl.json",
      "project": "sdras",
      "url": "https://github.com/sdras/night-owl-vscode-theme",
      "upstreamFile": "packages/ui/src/theme/themes/nightowl.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 22.1,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.475,
      "paletteMaxS": 0.523,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.1,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 25.9,
      "syntaxVsTextMinDeltaE": 29.9,
      "chartsMinDeltaE": 30.2,
      "textSeparationDeltaE": 24.9,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#82aaff",
      "hover": "#91b4ff",
      "active": "#9bbbff",
      "foreground": "#000000",
      "muted": "#82aaff80",
      "emphasis": "#82aaff"
    },
    "surface": {
      "background": "#011627",
      "foreground": "#d6deeb",
      "muted": "#162b3c",
      "mutedForeground": "#8e9ba8",
      "elevated": "#1f3445",
      "elevatedForeground": "#d6deeb",
      "raised": "#3b4d5e",
      "raisedForeground": "#d6deeb",
      "overlay": "#011627cc",
      "subtle": "#0b2233"
    },
    "interactive": {
      "border": "#3d4f61",
      "borderHover": "#3d4e5e",
      "borderFocus": "#82aaff",
      "selection": "#d6deeb29",
      "selectionForeground": "#d6deeb",
      "focus": "#82aaff59",
      "focusRing": "#82aaff61",
      "cursor": "#d6deeb",
      "hover": "#d6deeb1c",
      "active": "#d6deeb29"
    },
    "status": {
      "error": "#ef5350",
      "errorForeground": "#000000",
      "errorBackground": "#ef535024",
      "errorBorder": "#ef535073",
      "warning": "#ecc48d",
      "warningForeground": "#000000",
      "warningBackground": "#ecc48d24",
      "warningBorder": "#ecc48d73",
      "success": "#c5e478",
      "successForeground": "#000000",
      "successBackground": "#c5e47824",
      "successBorder": "#c5e47873",
      "info": "#82aaff",
      "infoForeground": "#000000",
      "infoBackground": "#82aaff24",
      "infoBorder": "#82aaff73"
    },
    "pr": {
      "open": "#c5e478",
      "draft": "#97a2af",
      "blocked": "#ecc48d",
      "merged": "#f78c6c",
      "closed": "#ef5350"
    },
    "syntax": {
      "base": {
        "background": "#25394a",
        "foreground": "#d6deeb",
        "comment": "#92a4a4",
        "keyword": "#c792ea",
        "string": "#ecc48d",
        "number": "#f78c6c",
        "function": "#82aaff",
        "variable": "#d6deeb",
        "type": "#2eff3e",
        "operator": "#83ae84"
      },
      "tokens": {
        "commentDoc": "#92a4a4",
        "stringEscape": "#83ae84",
        "keywordImport": "#c792ea",
        "storageModifier": "#c792ea",
        "functionCall": "#82aaff",
        "method": "#82aaff",
        "variableProperty": "#82aaff",
        "variableOther": "#d6deeb",
        "variableGlobal": "#f78c6c",
        "variableLocal": "#83ae84",
        "parameter": "#d6deeb",
        "constant": "#f78c6c",
        "class": "#2eff3e",
        "className": "#2eff3e",
        "interface": "#2eff3e",
        "struct": "#2eff3e",
        "enum": "#2eff3e",
        "typeParameter": "#2eff3e",
        "namespace": "#2eff3e",
        "module": "#c792ea",
        "tag": "#c792ea",
        "jsxTag": "#c792ea",
        "tagAttribute": "#82aaff",
        "tagAttributeValue": "#ecc48d",
        "boolean": "#f78c6c",
        "decorator": "#c792ea",
        "label": "#82aaff",
        "regexp": "#ecc48d"
      }
    },
    "charts": {
      "series": [
        "#82aaff",
        "#8482ff",
        "#c5e478",
        "#ecc48d",
        "#ef5350"
      ]
    },
    "chat": {
      "background": "#011627",
      "userMessage": "#d6deeb",
      "userMessageBackground": "#1f3445",
      "assistantMessage": "#d6deeb",
      "assistantMessageBackground": "#162b3c",
      "timestamp": "#97a2af",
      "divider": "#3d4f61",
      "typing": "#97a2af"
    },
    "loading": {
      "spinner": "#82aaff",
      "spinnerTrack": "#162b3c",
      "skeleton": "#162b3c",
      "shimmer": "#304354"
    },
    "tools": {
      "background": "#162b3c",
      "border": "#3d4f61",
      "headerHover": "#2e4152",
      "icon": "#82aaff",
      "title": "#d6deeb",
      "description": "#97a2af",
      "edit": {
        "added": "#c5e478",
        "addedBackground": "#c5e47824",
        "removed": "#ef5350",
        "removedBackground": "#ef535024",
        "modified": "#82aaff",
        "modifiedBackground": "#82aaff24",
        "lineNumber": "#97a2af"
      }
    },
    "markdown": {
      "heading1": "#d6deeb",
      "heading2": "#d6deeb",
      "heading3": "#d6deeb",
      "heading4": "#d6deeb",
      "link": "#82aaff",
      "linkHover": "#91b4ff",
      "inlineCode": "#ecc48d",
      "inlineCodeBackground": "#162b3c",
      "blockquote": "#97a2af",
      "blockquoteBorder": "#3d4f61",
      "listMarker": "#82aaffbf",
      "bold": "#d6deeb",
      "italic": "#d6deebe6",
      "strikethrough": "#97a2af",
      "hr": "#3d4f61"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#c0686e",
        "foreground": "#000000",
        "contrast": 5.45
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#d2a491",
        "foreground": "#000000",
        "contrast": 9.46
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#cfb56a",
        "foreground": "#000000",
        "contrast": 10.47
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#dfdcac",
        "foreground": "#000000",
        "contrast": 14.97
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#abd16c",
        "foreground": "#000000",
        "contrast": 12.07
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#ace2a6",
        "foreground": "#000000",
        "contrast": 14.18
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#6ccf7b",
        "foreground": "#000000",
        "contrast": 10.85
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#6dd0b5",
        "foreground": "#000000",
        "contrast": 11.34
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#6bc0ce",
        "foreground": "#000000",
        "contrast": 10.06
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#6399ca",
        "foreground": "#000000",
        "contrast": 6.94
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#5b68c5",
        "foreground": "#ffffff",
        "contrast": 4.96
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#9a8ecf",
        "foreground": "#000000",
        "contrast": 7.14
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#9e61c7",
        "foreground": "#000000",
        "contrast": 4.99
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#d78bd4",
        "foreground": "#000000",
        "contrast": 8.53
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#dba7c8",
        "foreground": "#000000",
        "contrast": 10.37
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#ca6294",
        "foreground": "#000000",
        "contrast": 5.69
      }
    ]
  }
}
